import {StateCreator} from 'zustand'
import type {IIdea, IIdeaVote} from '../../types'

/** The idea this comment belongs to is identified by `id` here — this is
 * the store action's payload shape, distinct from IIdeaComment (the
 * server-shaped display item that ends up inside `IIdea.comments`). */
interface IAddIdeaCommentPayload {
  id: string | number
  comment: string
  username: string
}

export interface IIdeationStore {
  ideas: IIdea[]
  ideasVotes: IIdeaVote[]
  setIdeas: (ideas: IIdea[]) => void
  addNewDraftIdea: (idea: IIdea) => void
  addNewIdeaComment: (comment: IAddIdeaCommentPayload) => void
  addNewVote: (votes: IIdeaVote[]) => void
  resetIdeationLocal: () => void
}

const initialState = {
  ideas: [],
  ideasVotes: [],
}

export const createIdeationSlice: StateCreator<
  IIdeationStore,
  [],
  [],
  IIdeationStore
> = set => ({
  ...initialState,

  setIdeas: ideas => set({ideas}),

  addNewDraftIdea: idea => set(state => ({ideas: [idea, ...state.ideas]})),

  addNewIdeaComment: comment =>
    set(state => {
      const ideasIndex = state.ideas.findIndex(idea => idea.id === comment.id)
      const newIdeas = [...state.ideas]
      if (ideasIndex >= 0) {
        newIdeas[ideasIndex] = {
          ...newIdeas[ideasIndex],
          comments: [comment, ...(newIdeas[ideasIndex].comments || [])],
        }
      }
      return {ideas: newIdeas}
    }),

  addNewVote: votes => set({ideasVotes: votes}),

  resetIdeationLocal: () => set(initialState),
})
